import api from "./core/api"

const BASE_PATH = '/users';

async function getUsers() {
    return await api.get(BASE_PATH + '/');
}

async function loginUser(email, password) {
    return await api.put(BASE_PATH + '/login', {email: email, password: password});
}

async function createUser(data) {
    return await api.post(BASE_PATH + '/new-user', data);
}

async function sendForgetPasswordEmail(email) {
    return await api.put(BASE_PATH + '/forgot-password', {email: email});
}

async function resetPassword(token, password) {
    return await api.put(BASE_PATH + '/reset-password', {token: token, password: password});
}

async function resendConfirmationEmail(data) {
    return await api.post(BASE_PATH + '/resend-confirmation-email', data);
}

async function confirmEmail(data) {
    return await api.put(BASE_PATH + '/confirm-email', data);
}

const user = {
    getUsers: getUsers,
    loginUser: loginUser,
    createUser: createUser,
    sendForgetPasswordEmail: sendForgetPasswordEmail,
    resetPassword: resetPassword,
    resendConfirmationEmail: resendConfirmationEmail,
    confirmEmail: confirmEmail
};

export default user;